import Util from '@/util/Util';

const utilMixin = {
    methods: {
        isObjectId(objectId: string): boolean {
            return Util.isObjectId(objectId);
        },

        isEmpty(word: string): boolean {
            return Util.isEmpty(word);
        },

        scrollToElementWithId(id: string): void {
            Util.scrollToElementWithId(id);
        },

        validateEmail(email: string): void {
            Util.validateEmail(email);
        }
    }
};

export default utilMixin;
